import { type ValueOf } from '@dni-types/utilities/value-of'
import { type BaseAnalyticsEvent } from './base/base-event'

export const ORDER_PLATFORM = {
  TO_CONSUMER: '2c',
  TO_RESELLER: '2r',
} as const

export type OrderPlatformType = ValueOf<typeof ORDER_PLATFORM>

export const ORDER_CANCEL_METHOD = {
  AUTO: 'auto',
  MANUAL: 'manual',
} as const

export type OrderCancelMethodType = ValueOf<typeof ORDER_CANCEL_METHOD>

export interface OrderReorderClickEvent extends BaseAnalyticsEvent {
  eventName: 'order_reorder_click'
  eventParams: {
    event_category: 'order_reorder_click'
    order_id: string
    /** 當前訂單分頁（all_statuses / pending / processing / completed / cancelled） */
    status_tab: string
    user_id: string
    platform: OrderPlatformType
  }
}

export interface OrderCancelClickEvent extends BaseAnalyticsEvent {
  eventName: 'order_cancel_click'
  eventParams: {
    event_category: 'order_cancel_click'
    order_id: string
    transaction_id: string
    /** 取消動作發生在哪個狀態分頁下（all_statuses / pending / processing） */
    page_source: string
    user_id: string
    platform: OrderPlatformType
  }
}

export interface OrderCancelSuccessEvent extends BaseAnalyticsEvent {
  eventName: 'order_cancel_success'
  eventParams: {
    event_category: 'order_cancel_success'
    order_id: string
    transaction_id: string
    cancel_method: OrderCancelMethodType
    user_id: string
    platform: OrderPlatformType
  }
}

export type OrderEvents = OrderReorderClickEvent | OrderCancelClickEvent | OrderCancelSuccessEvent
